import styled from 'styled-components';

export const LabelContainer = styled.div`
    width: auto;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    font-weight: bolder;
    font-size: 17px;
    margin: 0;
    padding: 0;
`

export const StyledP = styled.p`
    width: 100%;
    height: 100%;
    padding: 0 0 0 10px;
    margin: 0;
    display: flex;
    justify-content: flex-start;
    align-items: flex-end;
    font-weight: 600px;
    font-size: 16px;
    color: #a5a5a1;
`

export const StyledInput = styled.input `
    width: 100%;
    height: 40%;
    padding: 0 0 0 10px;
    margin: 0;
    display: flex;
    justify-content: flex-end;
    align-items: flex-end;
    font-size: 30px;
    color: #a5a5a1;
    border: 0;
    background-color: #dbdbd3;
`